import isNil from 'lodash-es/isNil';

import type { ExtendedBrightcovePlayer } from '../types';

import { NEXT_BUTTON_CLASS_NAME } from './constants';

export function removeNextButton(player: ExtendedBrightcovePlayer) {
  const btnEl = player.$(`.${NEXT_BUTTON_CLASS_NAME}`);
  if (!isNil(btnEl?.parentNode)) {
    btnEl.parentNode.removeChild(btnEl);
  }
}
